module.exports = __webpack_public_path__ + "img/menu-rotated-selected.1c0477b1.svg";